videos.classy.controller({
    name: "videosController",
    inject: ["$scope", "$rootScope", "authServiceFactory", "SchoolModelService", "$sce"],
    init: function() {
        this.$.SchoolModelService = this.SchoolModelService;
        this.$.resources = [];
        this.$.resources.training = [
            {
                country: "USA",
                title: "Intro to the New FAST Aid (US)",
                id: "uusmhzshfz",
                url: this.$sce.trustAsUrl("https://fast.wistia.com/embed/medias/uusmhzshfz.jsonp")
            },
            {
                country: "CAN",
                title: "Intro to the New FAST Aid (CAN)",
                id: "6rky0bu5ku",
                url: this.$sce.trustAsUrl("https://fast.wistia.com/embed/medias/6rky0bu5ku.jsonp")
            },
            {
                title: "FAST Orientation Training",
                id: "t7x28k1td9",
                url: this.$sce.trustAsUrl("https://fast.wistia.com/embed/medias/t7x28k1td9.jsonp")
            },
            {
                title: "FAST Award Training",
                id: "ubxkxlj82r",
                url: this.$sce.trustAsUrl("https://fast.wistia.com/embed/medias/ubxkxlj82r.jsonp")
            }
        ];
        this.$.resources.resources = [
            {
                title: "Before The Application Arrives",
                id: "rpdmcarwtg",
                url: this.$sce.trustAsUrl("https://fast.wistia.com/embed/medias/rpdmcarwtg.jsonp")
            },
            {
                title: "How To Create Effective Financial Aid Policies That Reflect Your Mission",
                id: "oqyot078dc",
                url: this.$sce.trustAsUrl("https://fast.wistia.com/embed/medias/oqyot078dc.jsonp")
            },
            {
                title: "Strategic Use of Financial Aid (Live Q&A)",
                id: "jkj93l0wkv",
                url: this.$sce.trustAsUrl("https://fast.wistia.com/embed/medias/jkj93l0wkv.jsonp")
            },
            {
                title: "How To Ensure Your Financial Aid Formula Is Accurate Objective and Mission-Appropriate",
                id: "5v6j0l2tqo",
                url: this.$sce.trustAsUrl("https://fast.wistia.com/embed/medias/5v6j0l2tqo.jsonp")
            },
            {
                title: "The Competitive Use of Financial Aid When Recruiting and Re-Recruiting Mission Appropriate Students",
                id: "cc2xaoml6h",
                url: this.$sce.trustAsUrl("https://fast.wistia.com/embed/medias/cc2xaoml6h.jsonp")
            },
            {
                title: "The True Cost of Budgeting For Financial Aid",
                id: "5pdyhrhodz",
                url: this.$sce.trustAsUrl("https://fast.wistia.com/embed/medias/5pdyhrhodz.jsonp")
            },
            {
                title: "Tuition Remission or No Tuition Remission, That Is The Question",
                id: "25ckml4j1i",
                url: this.$sce.trustAsUrl("https://fast.wistia.com/embed/medias/25ckml4j1i.jsonp")
            },
            {
                title: "Financial Aid Forensics: An Investigative Eye on REAL Parent Applications",
                id: "pg2u328vf0",
                url: this.$sce.trustAsUrl("https://fast.wistia.com/embed/medias/pg2u328vf0.jsonp")
            },
            {
                title: "A Walk-Through of How To Handle Tough Financial Aid Applications",
                id: "cbugxferfs",
                url: this.$sce.trustAsUrl("https://fast.wistia.com/embed/medias/cbugxferfs.jsonp")
            },
            {
                title: "Financial Aid Forensics: Dissecting a Real Family Application",
                id: "fz3xcvqfkj",
                url: this.$sce.trustAsUrl("https://fast.wistia.com/embed/medias/fz3xcvqfkj.jsonp")
            }
        ];
    }
});
